// axiosSetup.js
import axios from 'axios';
import { getNavigate } from './navigationService';
import { dedupeWrites } from './writeGuards';

// Двойное нажатие «Сохранить» не задваивает запись (writeGuards.js).
dedupeWrites(axios);

const SUBSCRIPTION_FREE_ROUTES = [
  "/wildberries/planUnit",
  "/ozon/planUnit",
  "/referral",
  "/payment",
  "/mydata",
  "/sellertnewuserpage",
  "/addnewcompany",
  "/admin",
  "/adminPage",
];

function isSubscriptionFreeRoute() {
  if (typeof window === "undefined") return false;

  const pathname = window.location?.pathname || "";
  return SUBSCRIPTION_FREE_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Проверяем, соответствует ли ошибка условию
    if (
      error.response &&
      error.response.data &&
      error.response.data.redirect &&
      error.response.data.message === "Подписка истекла. Оплатите подписку."
    ) {
      if (isSubscriptionFreeRoute()) {
        return Promise.reject(error);
      }

      // Без всплывающего «Подписка истекла»: страница «Оплата» сама объясняет, что случилось
      // (решение Operus 23.10). Если редирект ещё не запущен, запускаем его
      const navigate = getNavigate();
      if (navigate) {
        navigate(error.response.data.redirect);
      } else {
        window.location.href = error.response.data.redirect;
      }
      // Возвращаем промис, который не резолвится, чтобы остановить дальнейшую цепочку обработки
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);
